<template>
  <div>
    <div
      class="bg-dokBlue-lighter text-dokBlue-ultra text-base font-EffraR w-full flex items-center gap-x-2 h-12 px-2 rounded-t-lg"
    >
      <img src="/svg/consultation/eyebgblue.svg" />
      Cette note est uniquement visible par le praticien qui l'a rédigé
    </div>
    <div
      class="bg-white px-8 rounded-b-lg py-5 flex flex-col gap-y-6 w-full border-2 border-t-0 border-solid border-otgray"
    >
      <div class="flex flex-row gap-x-1">
        <img src="/svg/consultation/confidential-note.svg" />
        <h1 class="text-xl font-EffraR text-black">
          Note confidentielle
        </h1>
      </div>

      <hr class="border border-solid border-gray-200" />
      <div v-if="!loader" v-html="data.note || '--'">
      </div>

      <div
        class="bg-grayxx w-full h-6 rounded animate-pulse"
        v-if="loader"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    consultationID: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loader: true,
      data: {}
    };
  },
  created() {
    this.getNoteConfidentielle();
  },
  methods: {
    async getNoteConfidentielle() {
      await this.$store.dispatch("consultation/GET_NOTE_CONFIDENTIELLE", {
        id: this.consultationID,
        onData: ({ ok, data }) => {
          if (ok) {
            this.data = data;
            this.loader = false;
          }
        }
      });
    }
  }
};
</script>

<style></style>
